import { Button } from '@mui/material';
import { useDeviceType } from '../hooks/useDeviceType';
import Column from './Column';
import Spacer from './Spacer';
import Row from './Row';
import { type JSX } from 'react';

interface ButtonProps {
  label?: string;
  onClick?: () => void;
  showCondition?: boolean;
  disabled?: boolean;
  component?: JSX.Element;
  className?: string;
}

interface ButtonFooterProps {
  primaryButton: ButtonProps;
  secondaryButton: ButtonProps;
  tertiaryButton?: ButtonProps;
}

const ButtonFooter: React.FC<ButtonFooterProps> = ({
  primaryButton,
  secondaryButton,
  tertiaryButton,
}) => {
  const { isMobile, isTablet } = useDeviceType();

  return (
    <>
      <Spacer height='sm' />
      {isMobile || isTablet ? (
        <Column style={{ alignItems: 'center' }}>
          {tertiaryButton?.showCondition && tertiaryButton?.component ? (
            <>
              {tertiaryButton?.component}
              <Spacer height='xs' />
            </>
          ) : null}
          <Button
            className='mobile'
            color='primary'
            disabled={primaryButton.disabled}
            onClick={primaryButton.onClick}>
            {primaryButton.label}
          </Button>
          {secondaryButton.showCondition && (
            <>
              <Spacer height='xs' />
              <Button
                className='mobile'
                color='secondary'
                variant='outlined'
                disabled={secondaryButton.disabled}
                onClick={secondaryButton.onClick}>
                {secondaryButton.label}
              </Button>
            </>
          )}
        </Column>
      ) : (
        <Row
          style={{
            justifyContent: `${secondaryButton.showCondition ? 'space-between' : 'flex-end'}`,
          }}>
          {secondaryButton.showCondition && (
            <Button
              className={secondaryButton.className ? secondaryButton.className : 'back'}
              color='secondary'
              variant='outlined'
              disabled={secondaryButton.disabled}
              onClick={secondaryButton.onClick}>
              {secondaryButton.label}
            </Button>
          )}
          <Row style={{ alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
            {tertiaryButton?.showCondition && tertiaryButton?.component ? (
              <>
                {tertiaryButton?.component}
                <Spacer width='sm' />
              </>
            ) : null}
            <Button
              className={primaryButton.className ? primaryButton.className : 'nextStep'}
              disabled={primaryButton.disabled}
              onClick={primaryButton.onClick}
              color='primary'>
              {primaryButton.label}
            </Button>
          </Row>
        </Row>
      )}
    </>
  );
};

export default ButtonFooter;
